
import { useTranslation } from 'react-i18next';
import { Github, Linkedin, Instagram, Mail } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => {
  const { t } = useTranslation();
  
  const currentYear = new Date().getFullYear();
  
  const quickLinks = [
    { key: 'services', href: '#services' },
    { key: 'projects', href: '#projects' },
    { key: 'process', href: '#process' },
    { key: 'contact', href: '#contact' },
  ];
  
  const socialLinks = [
    { icon: <Github className="w-5 h-5" />, href: 'https://github.com/guilhermebalieloroqt', label: 'GitHub' },
    { icon: <Linkedin className="w-5 h-5" />, href: 'https://www.linkedin.com/in/guilhermebalielo', label: 'LinkedIn' },
    { icon: <Instagram className="w-5 h-5" />, href: 'https://www.instagram.com/gf.balielo', label: 'Instagram' },
    { icon: <Mail className="w-5 h-5" />, href: 'mailto:hi@balielodev.com', label: 'Email' }
  ];
  
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <footer id="contact" className="bg-background border-t border-white/5 mt-20">
      <div className="container-custom py-16 md:py-20">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-dark rounded-xl flex items-center justify-center font-black text-background text-lg shadow-lg">
                  B
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-primary rounded-full animate-pulse" />
              </div>
              <span className="text-2xl font-black text-white tracking-tight">
                balielo<span className="text-primary">.dev</span>
              </span>
            </div>
            <p className="text-gray-400 mb-4">
              Python Full-Stack & IA Agent Developer
            </p>
            <p className="text-sm text-gray-500">
              {t('footer.available_in')}
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              {t('footer.quick_links')}
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.key}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-primary transition-colors duration-300 text-left"
                  >
                    {t(`nav.${link.key}`)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Social Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">
              {t('footer.social')}
            </h4>
            <div className="flex gap-3 mb-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-white/10 border border-white/10 hover:border-primary/50 hover:bg-white/10 flex items-center justify-center transition-all duration-300"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            
            {/* Language Switcher */}
            <div className="mt-4">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex items-center justify-center">
            <p className="text-sm text-gray-500 text-center">
              © {currentYear} Balielo.dev • {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
